import React from 'react'
// import CarbonMain from './CarbonMain/CarbonMain'
import MachiningCentersCarbon from './MachiningCentersCarbon/MachiningCentersCarbon'
import CuttingMachines from './CuttingMachines/CuttingMachines'
import HybridSystemsCarbon from './HybridSystems/HybridSystemsCarbon'
import AutoclavesCarbon from './AutoclavesCarbon/AutoclavesCarbon'
import HydraulicCarbon from './HydraulicPressCarbon/HydraulicCarbon'
// import NewsPreview from '../../Modules/NewsBlock/NewsPreview'
import HeaderEngineering from '../../Modules/HeaderEngineering/HeaderEngineering'

const Index = () => {
  return (
    <div>
      <HeaderEngineering />
      {/*<CarbonMain />*/}
      <MachiningCentersCarbon />
      <CuttingMachines />
      <HybridSystemsCarbon />
      <AutoclavesCarbon />
      <HydraulicCarbon />
      {/*<NewsPreview />*/}
    </div>
  )
}

export default Index
